module.exports = __webpack_public_path__ + "img/logo-main-min.459945dc.png";